
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h1fbdfea3ad6d664e': html`Dala ito ng
                    <a href="${0}">Folksonomy Engine project</a>. Huwag
                    mag-atubiling lumahok o magbigay ng feedback`,
'h5d824b4954e56ea5': html`Scan your <span class="everyday">everyday</span> <span class="foods">foods</span>`,
'h6bdd1b427aa985a4': html`Binibigyang-daan ka ng tool na ito na itama ang listahan ng mga sangkap. Maaari kang magdagdag, mag-alis o mag-edit ng
                listahan ng mga sangkap.
                <br>
                Ang karakter na ito <span class="highlight">␣</span> ay kumakatawan sa isang espasyo.
                <br>
                Ang karakter na ito <span class="highlight">↩︎</span> ay kumakatawan sa isang line break. `,
'hb28f1f2ec1744ee9': html`Ang mga katangiang ito ay nilikha at isinampa ng mga user para sa anumang uri ng paggamit. Huwag mag-atubiling
                    idagdag ang iyong sarili. Ang mga pag-aari at halaga na iyong nilikha
                    <strong>ay dapat na makatotohanan</strong>. Maaari mong sumisid sa
                    <a href="${0}">ang listahan ng mga property na ginagamit na ng komunidad</a>
                    o tuklasin ang
                    <a href="${1}">dokumentasyon ng mga property at ang search engine nito</a>.`,
's000a5b76bd3a01c2': `Nilo-load ang mga katangian...`,
's000d98595e959c1e': `Get It On Google Play`,
's013bdc8cf0d3583d': `Tulungan mo kami para sa mga sangkap`,
's01d2865e3e1d5501': `Thank you for your assistance!`,
's02ce7a2e7c1b020b': `I-validate ang crop`,
's03e9c8114521b998': `I-edit ko ang mga sangkap`,
's05ec315d9308091a': `Icon ng mga sulok ng barcode`,
's061eb5af92512c85': `Na-save! Maaari ka bang tumulong sa isa pa?`,
's06847c221c4c0bc1': `Gusto kong gumawa ng property para [ilarawan ang iyong kaso ng paggamit]...`,
's06f6c6f99db6b552': `Orihinal`,
's081e2ad82db71e1d': `Pinagsama-samang mga Halaga`,
's09205907b5b56cda': `Hindi`,
's0b4235aae602a950': `dedikadong dokumentasyon`,
's0bb2d48532acc455': `I-download ang CSV`,
's0d5b7fee0311db68': `Property`,
's0fb218abc2e157ed': `I-invalidate ang larawan`,
's100c4928cc74642a': `support the advancement of public health research.`,
's10db5498186c083b': `Kanselahin ang pag-crop`,
's11a18a69b30b65ed': `Tulungan kaming ayusin ang mga error sa listahan ng mga sangkap`,
's1205d5f6fccf8e69': `Halaga ng Ari-arian`,
's15d64a0a6715285a': `Bagong susi`,
's166bd56d19670a72': `Zoom`,
's19059bf0c4f7c162': `Lugar ng pagpili`,
's1a52515ec8ddade8': `Product barcode`,
's1c5031113de500ce': `keeping our database open &amp; available to all,`,
's1dc4daf989c71284': `Tulungan kaming itama ang nutritional information`,
's1e00019dc454872d': `Mangyaring magbigay ng pangalan ng property gamit ang property-name attribute.`,
's1e49126af0935a5b': `Listahan ng mga produkto na gumagamit ng property na ito`,
's21e73088de6f26f3': `I-download sa App Store`,
's255857544a9d5ec0': `Reset`,
's25e94495991e95ba': `Thanks for your help! Can you assist with another question?`,
's2ceb11be2290bb1b': `Cancel`,
's2db7b654c0a9bde0': `Idokumento ang ari-arian`,
's300b3a6ee4e1252d': str`Hindi magandang Tugma ${0}%`,
's33f786bb6b4f0cf4': `Resulta ng Pag-crop`,
's33f85f24c0f5f008': `I-save`,
's34be4af4e8fec4ae': `Magtanong muna sa komunidad`,
's36d86adc823cbfa6': `Bago gumawa ng bagong property, talakayin ito sa komunidad:`,
's3781d25aa51a736c': `Folksonomy Engine Documentation`,
's383ae4449428b61e': `I-reset ang pag-crop`,
's39bcf88721a1e8ee': `I-reset ang pagpili`,
's39e14e14300694c7': `Dokumentasyon at Mga Alituntunin`,
's3b430cfa5c1fe7f4': str`Dokumentasyon para sa ${0}`,
's3f4e4b52f230a892': `Canvas ng larawan`,
's417b90913e05bc17': `Preview`,
's41f7dca46d3f1b4a': `Value`,
's422bba9636ce2489': `Larawan sa gitna`,
's42dd66b2441566fd': `Icon sa gitna`,
's43df2e8395f6834e': str`Please give to our ${0} Fundraiser`,
's453188ea728f64da': `Magdagdag ng sustansya`,
's453ab0dbb9b5c777': `Baguhin ang laki nang tama`,
's475b08749d0706ed': `Help us inform millions of consumers around the world about what they eat`,
's49730f3d5751a433': `Loading...`,
's4bbc7472834a9686': `Your browser does not support barcode scanning.`,
's4d42cc7e00076a3b': `Bilang ng Produkto`,
's4df2f533c0c1e7d0': `Mga kontrol sa imahe`,
's4e94adf723979402': `Open Food Facts needs your help with this product.`,
's4f4886341969d552': `Ilipat ang pagpili`,
's4f751fb9b3ed766c': `Paggawa ng Bagong Ari-arian`,
's547c12ae169d00bc': `Available on F-Droid`,
's5560fb119e40923d': `Ilagay ang pangalan ng property...`,
's55d7249883a98ca1': `tungkol sa property na ito sa Open Food Facts wiki`,
's565867d84c04aea2': `I-filter ang mga katangian...`,
's5666afe5cd0166de': `Mangyaring ayusin ang mga error o baguhin ang teksto bago kumpirmahin`,
's57472465a23b41db': `Values`,
's58e1eeea7a60ae51': `Naglo-load ng mga produkto...`,
's59df20feee978e5b': `Error: Invalid value.`,
's5c92c0051d44b6de': `Tulungan kaming itama ang nutritional information.`,
's5dd6f12783fca34f': `I-edit ang listahan ng mga sangkap`,
's5e8250fb85d64c23': `I-close`,
's5ed03bb1f3a15949': `Picture`,
's6306a31415aea913': `I SUPPORT`,
's6498dfe4855bb3a7': `unit`,
's64ef2a6c2dd1d3d1': `Edit`,
's66413c24dcf680e2': `Skip`,
's67ae6594857a4d57': `Thanks for your contribution!`,
's6cee7cad81dfedd1': `Na-crop na Larawan`,
's6d7b6cdedaadfb6e': `Each donation counts! We appreciate your support in bringing further food transparency in the world.`,
's7124dde792a8faa2': `Android APK`,
's718dea04853f80ae': str`Magandang Tugma ${0}%`,
's71a5c9f4b68ef4d4': `Count`,
's74cb3d66f6a668e1': `Dokumentasyon`,
's787dd11bed0dc88a': `Baguhin ang laki sa kaliwa`,
's7ce4fd9430e80cea': `halaga`,
's801a05fa8e881f37': `Matuto pa tungkol sa paggawa at mga alituntunin ng ari-arian:`,
's8038273de2cf8b73': `Mangyaring pumili ng rehiyong i-crop.`,
's839cc2908a5387f2': `I-filter ang mga barcode...`,
's86197dcf3e96af64': `Mag-browse at maghanap ng mga umiiral nang property`,
's8a63be30a129a59c': `Baguhin ang laki sa ibaba`,
's8a8bfd67f2dd2810': `Download the OFF app with this QR code`,
's8af61807443f32a4': `Actions`,
's8b33c244759d7bd4': `Baguhin ang laki sa kanang itaas`,
's8db84aa4bc949af2': `Idokumento ang Bagong Ari-arian`,
's8f839a03997a16d7': `Tingnan ang Produkto`,
's901ae1e236ac45d3': `Kanselahin ang pagtanggal`,
's907f7a97c6b29425': `Magkaroon ng kamalayan na ang modelo ng data ay maaaring mabago. Gamitin sa iyong sariling peligro.`,
's95d23d03f9147581': `Unzoom`,
's976dfd19ef58a1e1': `Click to scan a barcode and find out its details (health, preferences, etc.)`,
's98ff35f2a00dc60d': `Mga sangkap:`,
's9a7f60fce090ecaf': `Nabigong i-load ang mga property. Pakisubukang muli mamaya.`,
's9b87abd68fb9df45': `Hindi nahanap? Lumikha ng bagong key {value}`,
's9c0f52425fd2f07e': `Maaaring Hindi Magtugma`,
's9fc41f789c63b40d': `Mga produkto`,
'sa1fa766e0d5634d7': `Walang Magagamit na Marka`,
'sa548778b24054030': `I-explore ang lahat ng naiambag na property mula sa proyekto ng Folksonomy Engine. Nagbibigay ang mga property na ito ng karagdagang metadata at mga insight tungkol sa mga produkto sa database ng Open Food Facts.`,
'sa63907958bd0ec4b': `Baguhin ang laki sa kaliwang itaas`,
'sa95b4224f685a36a': `Isara ang modal`,
'sab56a1d439576fd6': `Icon ng mungkahi`,
'sac47ea2901d04c15': `Baguhin ang laki sa kaliwang ibaba`,
'sb125227d436c2925': `Hanapin ang konsepto ng iyong ari-arian sa umiiral nang database ng mga katangian:`,
'sb125568d43642e6f': `Sagutin ang mga tanong tungkol sa produkto.`,
'sb1c538e038f9b214': str`Napakagandang Tugma ${0}%`,
'sb28639570ff3b852': `listahan ng lahat ng pag-aari`,
'sb3bdd638a58d30f4': `engage a community of committed citizens,`,
'sb3cbcc1bd0fff140': `Kapag na-verify mo na na ang iyong ari-arian ay hindi umiiral at ang komunidad ay sumang-ayon na ito ay kapaki-pakinabang, kailangan mo munang idokumento ito sa wiki.`,
'sb3d4f79d9d8b71e5': `Submit`,
'sb560fa37a7bfb6c2': `Walang nakitang mga produkto para sa property na ito.`,
'sb7f72e4c8a2d3357': `I-filter ang mga halaga...`,
'sb8178320160f84ea': `Ipakita ang crop`,
'sbad7d2734149470b': `Validate`,
'sbb623d6b18d966a0': `Nutrition facts are displayed on the packaging:`,
'sbd6be5cde472f37c': `Lahat ng insight ay nasagot na! Salamat sa iyong tulong!`,
'sbd9a0b2293b3cd3c': `Sukat ng serving`,
'sbe472dc3c2685985': `Kaukulang Halaga`,
'sc0520e1732a5c568': `Expand image`,
'sc0cc559e7ede852a': `Baguhin ang laki sa itaas`,
'sc1c08d0cbcc3bd24': `Hindi Nagtutugma`,
'sc52696641af72b53': `Install the app!`,
'sc5575e3107f87874': `Rotate image to the left`,
'sc57b630a7a70c61f': `Iminungkahing ayusin`,
'sc681b137e8f604f7': `Confirm deletion`,
'sc6daf8a31883f8b9': `Ilipat ang imahe`,
'sc895972c88d38ca5': `ari-arian ng folksonomy`,
'sca0c3305aff570b8': str`per specified serving "${0}"`,
'scace072bef961918': `Mga hilera`,
'scb3b0671d7b7f640': `Bagong halaga`,
'scb489a1a173ac3f0': `Oo`,
'scbab4bd737ba7934': str`group photo donation ${0}`,
'scd21019c3cd618f3': `Sumali sa Slack Discussion`,
'scdb6cad0b92721bf': `Walang nakitang mga ari-arian.`,
'scf23a05631f93732': `Kumpirmahin ang Tanggalin`,
'scfed2f270ef6a3aa': `Pumili ng lugar`,
'sd1022bc1ef9204f7': `Na-zoom na larawan`,
'sd1077c055cf9ba6b': `Tulungan kaming i-validate ang listahan ng mga sangkap ng produkto.`,
'sd698d21ddecba56b': `Hoy! Matutulungan mo kaming mapabuti ang impormasyon ng produkto sa pamamagitan ng pagsagot sa mga sumusunod na bahagi:`,
'sd82bc2decefa621b': `remain independent of the food industry,`,
'sdb97e5976482606e': `Tingnan kung mayroon nang property`,
'sdbf806fefc584115': `Dapat mong mahanap ang isang`,
'sdc673e73b5c13aea': `Burahin`,
'sdc792b75f1edcaba': `Tulungan kaming iwasto ang spelling ng mga sangkap.`,
'sdca5deead576ceee': `Baguhin ang laki sa kanan sa ibaba`,
'sdcc2555c5dde524f': `Sigurado ka bang gusto mong tanggalin ang item na ito? Ang pagkilos na ito ay hindi maaaring i-undo.`,
'se206feec7ec57b28': `per 100g`,
'se419a9ab36987490': `Mawalan ng bisa`,
'se5127cf0f92e7e48': `Tip: mahahanap mo rin ang`,
'se773f50d2a16d481': `Rotate image to the right`,
'sebb2c6c830a44574': `technical infrastructure (website/mobile app) &amp; a small permanent team`,
'sec6377f3c4e9b28c': `Magpapanukala ako ng mas magandang pananim`,
'seea3800e27baa686': `Mga Indibidwal na Produkto`,
'sefaba4adc4ec9219': `Mga Katangian ng Folksonomy`,
'seffa8ca49175b5f0': `Mga personalized na property`,
'sf44a6b3b232c28ea': str`Palitan ang kasalukuyang halaga ng ${0}`,
'sf4cd86a2f5ef2588': `Barcode ng Produkto`,
'sf57a61152168cc81': `Tulungan kaming itama ang pagtuklas ng sangkap`,
'sf88b90b8ba23871c': `Hindi Alam na Tugma`,
'sf9aee319a006c9b4': `Magdagdag`,
'sfacbbe968fa7d773': `Pangalan ng property:`,
'sfc40ea3d5d5aa6f8': `Your donations fund the day-to-day operations of our non-profit association:`,
'sfe87465d50530725': `Kaukulang halaga`,
's5f343a43e7ea9f91': `Error`,
'sd947a599045e9e0e': `Failed to check property conflicts. Please try again.`,
's92a0d19a28995530': `Success`,
's371091f240c17a7e': `Property renamed successfully!`,
's4603f58131a777bf': `Failed to rename property. Please try again.`,
's21694d2ab9c0bec5': `Property deleted successfully!`,
'scf78b75273a6b5fe': `Failed to delete property. Please try again.`,
's71ffcb25fc1c5356': `Rename this property`,
's60320a18282b2b33': `Rename`,
's6e2a82009cc3dfc7': `Delete this property`,
's8bccacf0fc176064': `Rename Property`,
's0df37909a355e56f': str`Rename property '${0}' to:`,
'sb550440eeb3f39c5': `New property name:`,
'sbb53591e587764b7': `Enter new property name...`,
's8acd49e96b4ee7d4': `Check Conflicts`,
'sd1cfdf0ef29cb6a5': `Property Rename Conflicts`,
'sf417737adaa5a8c2': str`Renaming '${0}' to '${1}' will affect:`,
's14571d0ac58a8b43': `Products with both properties:`,
'sb0d459e32656033f': `Products with old property only:`,
'sfa3027dde47305fe': `Products with new property only:`,
's9e5b8feb0892646e': `Do you want to proceed with the rename?`,
's97171907a2d1620b': `Proceed with Rename`,
's712d70fdcc3dd42b': `Delete Property`,
'sc11b78f2f3173f75': str`Are you sure you want to delete the property '${0}'?`,
's3b3fe4e829af3e8e': `This action cannot be undone.`,
's091d3d07b5b3076f': `OK`,
's72c9c4e6ab4ca7ae': `Value replaced successfully!`,
'sdd0eacd725bb2b1d': `Failed to replace value. Please try again.`,
'sfe87a7a8bed11acf': `Value deleted successfully!`,
'sccd2745bdd1087f6': `Failed to delete value. Please try again.`,
's88ece9a678e2f106': `Replace Value`,
's3355d65e22e222c9': str`Replace all instances of '${0}' with a new value:`,
's0d426d718d97d14e': `New value:`,
'se80a1ed3dcab7408': `Enter new value...`,
's2a8434b16dc214a3': `Replace`,
's8263352c7a634e7f': `Delete Value`,
'sebe99e3299746177': str`Are you sure you want to delete all instances of the value '${0}'?`,
's4b0b53abbd6af54a': `Replace this value across all products`,
'sb02836b5e3176cfe': `Delete this value from all products`,
    };
  